import { render, staticRenderFns } from "./ConversationListElement.vue?vue&type=template&id=54fcb614&"
import script from "./conversation-list-element.ts?vue&type=script&lang=ts&"
export * from "./conversation-list-element.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports